export enum ImageType {
  COVER = 'COVER',
  LOGO = 'LOGO',
  LIST = 'LIST',
}
